import { render, staticRenderFns } from "./OffersRoute.vue?vue&type=template&id=62bbe7ab&scoped=true&"
import script from "./OffersRoute.vue?vue&type=script&lang=js&"
export * from "./OffersRoute.vue?vue&type=script&lang=js&"
import style0 from "./OffersRoute.vue?vue&type=style&index=0&id=62bbe7ab&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62bbe7ab",
  null
  
)

export default component.exports